import React from "react";

const TitleQuoteForm = ({ title, subtitle }) => {
  return (
    <div className="titleQuoteForm">
      <h3 className="titleQuoteForm__title">{title}</h3>
      <p className="titleQuoteForm__subtitle">{subtitle}</p>
    </div>
  );
};

export default TitleQuoteForm;
